import { Card } from "react-bootstrap";
import _ from "lodash";
import JsonViewerComponent from "../../JsonViewer/JsonViewerComponent";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { SET_CATEGORY_JSON } from "../../../../store/actions";

const EquipmentUnitCategoryJsonView = () => {

    const dispatch = useDispatch();

    const categories = useSelector(state => state.category.categories);
    const selectedCategoryId = useSelector(state => state.category.selectedCategoryId);
    const isAddOrEditActive = useSelector(state => state.category.isAddOrEditActive);
    const categoryJson = useSelector(state => state.category.categoryJson);

    const [utils, setUtils] = useState({ categoryJson: {} });

    useEffect(() => {
        if(!_.isEmpty(selectedCategoryId)) {
            categories.forEach(category =>  {
                if(category.id === selectedCategoryId) {
                    setUtils({ ...utils, categoryJson: category.categoryJson });
                }
            });
        }
        else {
            setUtils({ ...utils, categoryJson: {} });
        }
    }, [selectedCategoryId]);

    useEffect(() => {
        if(!isAddOrEditActive) {
            setUtils({ ...utils, categoryJson: categoryJson });
        }
    }, [isAddOrEditActive]);

    useEffect(() => {
        try {
            setUtils({ ...utils, categoryJson: typeof categoryJson === "object" ? categoryJson : JSON.parse(categoryJson) });
        } catch (error) {
            // CATCH BLOCK TO PREVENT APP FROM CRASHING IN CASE PROVIDED JSON HAS SYNTAX ERRORS.
        }
    }, [categoryJson]);

    return (
        <Card className="w-100 mx-1">
            <div className="category-json-view">
                <b className="p-3 f-17">Equipment Unit Category Json</b>
            </div>
            {
                !isAddOrEditActive && _.isEmpty(utils.categoryJson) ?
                    <h5 className="vertical-center-align justify-center h-100">
                        <b>No category selected</b>
                    </h5>
                        :
                    <Card.Body className="p-0">
                        <JsonViewerComponent
                            onContentChange={(val) => dispatch({ type: SET_CATEGORY_JSON, payload: val })}
                            hideLineNumbers={true}
                            height={`${window.innerHeight - 200}px`}
                            content={JSON.stringify(utils.categoryJson, null, 2)}
                            readOnly={!isAddOrEditActive}
                            editorWidth={12}
                            editorDisplay={true}
                            previewWidth={0}
                            previewDisplay={false}
                            minimap={false}
                            wordWrap={false}
                            theme='light'
                            loadingContent='Loading...'
                            iconSize={'20px'}
                            iconGap={'8px'}
                        />
                    </Card.Body>
            }
        </Card>
    )
}

export default EquipmentUnitCategoryJsonView;